import React, { useState, useEffect, memo } from "react"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import ViewDesignationTable from "@/components/project-dashboard/view-designation/ViewDesignationTable"
import Loading from "@/components/common/Loading"
import { getDesignations } from "@/apis"
import { Link } from "react-router-dom"
import { Breadcrumbs, Typography } from "@material-ui/core"
import globalUseStyles from "@/globalUseStyles"
import PageHeader from "../shared-component/page-header"

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: theme.spacing(3),
    },
    addNewActionButton: {
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
}))

const ViewDesignation = memo((props) => {
    const { companyId } = props
    const classes = useStyles()
    const globalClasses = globalUseStyles()

    const [designationData, setDesignationData] = useState({
        loading: true,
        error: false,
        data: {
            generalDesignation: undefined,
            companyUniqueDesignation: undefined,
        },
    })

    useEffect(() => {
        const getDesignationsData = async () => {
            try {
                const designationResult = await getDesignations(companyId)
                const companyUniqueDesignation = []
                const generalDesignation = []
                designationResult.data.designations.forEach((designation) => {
                    if (designation.companyId) companyUniqueDesignation.push(designation)
                    else generalDesignation.push(designation)
                })
                setDesignationData({
                    loading: false,
                    error: false,
                    data: {
                        generalDesignation,
                        companyUniqueDesignation,
                    },
                })
            } catch (error) {
                setDesignationData((prev) => ({
                    ...prev,
                    loading: false,
                    error: true,
                    data: prev.data,
                }))
            }
        }
        getDesignationsData()
    }, [companyId])

    const Links = () => (
        <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to="/" className={globalClasses.link}>
                Home
            </Link>
            <Typography color="textPrimary">Designations</Typography>
        </Breadcrumbs>
    )

    return (
        <>
            <PageHeader pageTitle="Designations" links={<Links />} />
            {designationData.loading ? (
                <div className="wrapper">
                    <Loading />
                </div>
            ) : (
                <>
                    {designationData.error ? (
                        <div>Error</div>
                    ) : (
                        <Box className={classes.wrapper}>
                            <Box>
                                <ViewDesignationTable designationData={designationData} />
                            </Box>
                        </Box>
                    )}
                </>
            )}
        </>
    )
})

export default ViewDesignation
